import { render, staticRenderFns } from "./WorkDetail8.vue?vue&type=template&id=af1aa80a&scoped=true&"
import script from "./WorkDetail8.vue?vue&type=script&lang=js&"
export * from "./WorkDetail8.vue?vue&type=script&lang=js&"
import style0 from "./WorkDetail8.vue?vue&type=style&index=0&id=af1aa80a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af1aa80a",
  null
  
)

export default component.exports